import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import assign from 'lodash/assign';
import each from 'lodash/each';
import indexOf from 'lodash/indexOf';
import camelCase from 'lodash/camelCase';
import isObject from 'lodash/isObject';
import snakeCase from 'lodash/snakeCase';
import padStart from 'lodash/padStart';
// import * as dsbridge from './dsbridge'
import Router from 'next/router';
import config from './config';
// import Loadable from 'react-loadable'
// import UiToast from '../components/ui/toast'
// import LoadingBlock from 'components/ui/loading-block'

const formatStr = (str: string, data: object) => {
  if (str) {
    Object.keys(data).forEach((key) => {
      let val: any = data[key];
      if (!(val !== null && typeof val !== 'undefined')) {
        val = '';
      }
      str = str.replace(new RegExp(`\\{${key}\\}`, 'g'), <string>val);
    });
  }
  // str && forEach(data, (val, key) => {
  //     if (!(val !== null && val != 'undefined')) {
  //         val = '';
  //     }
  //     str = str.replace(new RegExp("\\{" + key + "\\}", "g"), val);
  // })
  return str;
};

/**
 * 统一格式化数字，保留1位小数
 * @param number 数字
 * @param isShort 为true时，大于10000的数字，显示为1.1万，大于100000000的数字，显示为1.1亿
 * @param isDivide 为true时，大于1000的数字，显示为1,000，否则显示为1000
 */
function formatNum(number, isShort = false, isDivide = true) {
  if (!number) {
    return number;
  }
  let strNum = `${number}`;
  let unit = '';
  if (isShort) {
    // if (number >= 100000000) {
    //   strNum = (Math.floor(number / 10000000) / 10).toFixed(1);
    //   unit = '亿';
    // } else

    if (number >= 10000) {
      strNum = (Math.floor(number / 1000) / 10).toFixed(1);
      unit = '万';
    }
  }

  const tem = strNum.split('.');

  return (
    (isDivide ? tem[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') : tem[0]) +
    (tem[1] ? `.${tem[1]}` : '') +
    unit
  );
}

/**
 * 获取时间
 * @param {Number|Date} time
 * @private
 */
function _getDate(time: number | Date) {
  let datetime;
  if (time instanceof Date) {
    datetime = time;
  } else {
    datetime = time ? new Date(time) : new Date();
  }
  return datetime;
}

/**
 * 格式化时间，按照不同的格式返回不同的字符串
 * @param  {Number/Date} time   时间戳，如果不传，或者为null，则为当前时间
 * @param  {String} format 字符串格式 (Y:年, M:月, D:日, h:小时, m:分钟, s:秒)
 * @return {String}        字符串
 */
function formatTime(time: number | Date, format: string = 'yyyy-MM-dd hh:mm:ss') {
  const datetime = _getDate(time);

  const o = {
    'M+': datetime.getMonth() + 1, // month
    'd+': datetime.getDate(), // day
    'h+': datetime.getHours(), // hour
    'm+': datetime.getMinutes(), // minute
    's+': datetime.getSeconds(), // second
    'q+': Math.floor((datetime.getMonth() + 3) / 3), // quarter
    S: datetime.getMilliseconds(), // millisecond
  };

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, `${datetime.getFullYear()}`.substr(4 - RegExp.$1.length));
  }

  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length),
      );
    }
  });
  return format;
}

// 毫秒，时间戳
type Ts = number;
type Seconds = number;

const getRemainTime = (time: Ts) => {
  time /= 1000;

  const result = {
    h: Math.floor(time / 3600),
    m: Math.floor((time % 3600) / 60),
    s: Math.floor(time % 60),
  };
  let str = '';
  if (result.h > 0) {
    str += `${result.h}小时`;
  }

  if (result.m > 0) {
    str += `${result.m}分`;
  }

  if (result.s > 0 && result.h === 0) {
    str += `${result.s}秒`;
  }

  return str;
};

const getTimerText = (seconds: Seconds, format: any = {}) => {
  if (seconds < 0) {
    return '';
  }
  const { d = false, h = true, m = true, s = true } = format;

  // 大于24小时，显示天数，向上取整
  if (d && seconds > 60 * 60 * 24) {
    const days = Math.ceil(seconds / (3600 * 24));
    return `${days}天`;
  }

  const hour = Math.floor(seconds / (60 * 60));
  const minute = Math.floor((seconds % (60 * 60)) / 60);
  const second = seconds % 60;
  const textArray: Array<string> = [];
  if (h) {
    textArray.push(padStart(`${hour}`, 2, '0'));
  }
  if (m) {
    textArray.push(padStart(`${minute}`, 2, '0'));
  }
  if (s) {
    textArray.push(padStart(`${second}`, 2, '0'));
  }
  return textArray.join(':');
};

const getLastTime = (time: Ts, isLast = true) => {
  const timespan = Date.now() - time;

  if (timespan < 1000 * 60 * 60) {
    let minutes = Math.floor(timespan / (1000 * 60));
    minutes = minutes || 1;
    if (minutes <= 3) {
      return '刚刚';
    }
    return `${minutes}分钟${isLast ? '前' : ''}`;
  }
  if (timespan < 1000 * 60 * 60 * 24) {
    const tmsp = timespan % (1000 * 60 * 60);
    const minutes = Math.floor(tmsp / (1000 * 60));
    return `${Math.floor(timespan / (1000 * 60 * 60))}小时${minutes || 1}分钟${isLast ? '前' : ''}`;
  }
  if (timespan < 1000 * 60 * 60 * 24 * 7) {
    return `${Math.floor(timespan / (1000 * 60 * 60 * 24))}天${isLast ? '前' : ''}`;
  }

  return formatTime(time, 'MM-dd hh:mm');
};

/**
 * 获取随机字符串长度
 * @param maxLen
 * @returns {string}
 */
const getRandomString = (maxLen = 6) => {
  let str = Math.random().toString(36).substring(2);
  while (str.length < maxLen) {
    str += Math.random().toString(36).substring(2);
  }
  return str.substring(0, maxLen);
};

const transformKeys = (obj: object, action: 'camel' | 'snake', transKeys?) => {
  action = action || 'camel';

  let data = assign({}, obj);
  let tmpData = {};

  if (isArray(obj)) {
    data = assign([], obj);
    tmpData = [];
  }

  each(data, (value, key) => {
    if (key !== '_id') {
      if (isArray(transKeys)) {
        if (indexOf(transKeys, key) > -1) {
          key = action === 'camel' ? camelCase(key) : snakeCase(key);
        }
      } else {
        key = action === 'camel' ? camelCase(key) : snakeCase(key);
      }
    }

    if (isObject(value) || isArray(value)) {
      tmpData[key] = transformKeys(value, action);
    } else {
      tmpData[key] = value;
    }
  });

  return tmpData;
};

const getConstellation = (index) => {
  return [
    '保密',
    '白羊座',
    '金牛座',
    '双子座',
    '巨蟹座',
    '狮子座',
    '处女座',
    '天秤座',
    '天蝎座',
    '射手座',
    '魔蝎座',
    '水瓶座',
    '双鱼座',
  ][index || 0];
};

/**
 * 获取 [min,max] 范围内的随机数
 * @param min
 * @param max
 * @returns {*}
 * @private
 */
const getRangeNum = (min, max) => {
  return Math.floor(Math.random() * (max + 1 - min)) + min;
};

const getViewCount = (n) => {
  n = parseInt(n, 10);
  switch (n) {
    case n < 20:
      n *= 100;
      break;
    case n < 50:
      n *= 80;
      break;
    default:
      n *= 68;
      break;
  }

  return formatNum(n + Math.round(Math.random() * 100));
};

const formatImgUrl = (url) => {
  if (!url) return '';
  if (url.indexOf('http://') > -1) {
    url = url.replace('http', 'https');
  }

  if (!config.release && !config.grey) {
    if (url.indexOf('test.img.sumeme') > -1) {
      url = url.replace('test.img', 'test-img');
    }
  }

  return url;
};

const formatImgSize = (url) => {
  if (!url) {
    return '';
  }
  if (url.indexOf('img-photo') > -1 && url.indexOf('imageView2') < 0) {
    url = `${url.split('?')[0]}?imageView2/1/w/400/h/400/q/75|imageslim`;
  }
  return url;
};

const loadJs = (url, callback) => {
  const script: HTMLScriptElement = document.createElement('script');
  script.type = 'text/javascript';
  if (typeof callback !== 'undefined') {
    // if (script.readyState) {
    //     script.onreadystatechange = function () {
    //         if (script.readyState == "loaded" || script.readyState == "complete") {
    //             script.onreadystatechange = null;
    //             callback();
    //         }
    //     }
    // } else {
    script.onload = function () {
      callback();
    };
    // }
  }
  script.src = url;
  document.body.appendChild(script);
};
const loadModuleJs = (url, callback) => {
  const script: HTMLScriptElement = document.createElement('script');
  script.type = 'module';
  // script.crossOrigin = 'anonymous'
  if (typeof callback !== 'undefined') {
    // if (script.readyState) {
    //     script.onreadystatechange = function () {
    //         if (script.readyState == "loaded" || script.readyState == "complete") {
    //             script.onreadystatechange = null;
    //             callback();
    //         }
    //     }
    // } else {
    script.onload = function () {
      callback();
    };
    // }
  }
  script.src = url;
  document.body.appendChild(script);
};

const scrollTop = () => {
  setTimeout(() => {
    window.scrollTo(0, document.body.scrollTop + 1);
    document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1);
  }, 200);
};

const scrollBottom = () => {
  setTimeout(() => {
    window.scrollTo(0, 999999);
    document.body.scrollTop >= 1 && window.scrollTo(0, 999999);
  }, 200);
};

const parseQueryString = (url?) => {
  const urlStr = url || (typeof location !== 'undefined' ? location.href : '');
  let str = urlStr;
  if (str.indexOf('?') > -1) {
    str = urlStr.split('?')[1];
  }
  if (str.indexOf('#') > -1) {
    str = str.split('#')[0];
  }
  const items = str.split('&');
  const result = {};

  for (let i = 0; i < items.length; i++) {
    const arr = items[i].split('=');
    result[arr[0]] = decodeURIComponent(arr[1]);
  }
  // console.log('parseQueryString url=>',urlStr,'result=>',result)
  return result;
};

/**
 * 转换 为埋点索引号
 * @param index
 * @returns {string}
 * @desc eg: 1 ==> 001
 */
const getSaIndex = (index) => {
  return padStart(index, 3, '0');
};

const reload = ({ pathname = '', search = '', tip = '页面刷新中...' } = {}) => {
  // UiToast.loading(tip)

  if (!pathname && location.hash) {
    // 默认情况有hash，location.href 不会刷新，所以采用 reload 方法刷新
    location.reload();
    return;
  }
  if (!pathname) {
    pathname = location.pathname;
    search = location.search;
  }

  // search = search.split('__r=')[0].replace(/[?&]+$/ig, '')
  // search = search + (search ? '&' : '?') + '__r=' + Date.now();
  // console.log("logout:",pathname,search)
  location.href = `${location.protocol}//${location.host}${pathname}${search}${location.hash}`;
};

const cssPx2ViewportPx = (px) => {
  let innerWidth = window.innerWidth;
  if (innerWidth < 320) {
    innerWidth = 320;
  }
  if (innerWidth > 750) {
    innerWidth = 750;
  }
  return (innerWidth / 750) * parseInt(px, 10);
};

const navBackTimer = null;
const navBack = () => {
  clearBackTimer();
  Router.back();
  // navBackTimer = setTimeout(() => {
  //     dsbridge.closeWebview()
  // }, 200);
};

const clearBackTimer = () => {
  // clearTimeout(navBackTimer)
};

function getRAF() {
  return (
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    function (cb) {
      return setTimeout(cb, 17);
    }
  );
}

function getCAF() {
  return (
    window.cancelAnimationFrame ||
    window.mozCancelAnimationFrame ||
    window.webkitCancelAnimationFrame ||
    window.webkitCancelRequestAnimationFrame ||
    window.msCancelAnimationFrame ||
    window.oCancelAnimationFrame ||
    function (id) {
      clearTimeout(id);
    }
  );
}

const redirectRoom = (roomId) => {
  Router.push(`/${roomId}`);
};

const getMonthFirstDate = (time) => {
  const date = time ? new Date(time) : new Date();
  date.setDate(1);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

const getMonthLastDate = (time) => {
  const date = _getDate(time);
  let currentMonth = date.getMonth();
  const nextMonth = ++currentMonth;
  const nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1).getTime();
  const oneDay = 1000 * 60 * 60 * 24;
  const lastTime = new Date(nextMonthFirstDay - oneDay);
  return new Date(date.getFullYear(), date.getMonth(), lastTime.getDate());
};

const getNextMonthFirstDate = (time) => {
  const date = _getDate(time);
  let currentMonth = date.getMonth();
  const nextMonth = ++currentMonth;
  return new Date(date.getFullYear(), nextMonth, 1).getTime();
};

/**
 * 获取周一
 * @param time
 */
const getWeekFirstDate = (time) => {
  const date = _getDate(time);
  let day = date.getDay();
  const today = date.getDate();

  day = day === 0 ? 7 : day;

  return new Date(date.getFullYear(), date.getMonth(), today - day + 1);
};

/**
 * 获取周日
 * @param time
 */
const getWeekLastDate = (time) => {
  const date = _getDate(time);
  let day = date.getDay();
  const today = date.getDate();

  day = day === 0 ? 7 : day;

  return new Date(date.getFullYear(), date.getMonth(), today + 6 - day + 1);
};

const getPrevDate = (time) => {
  time = _getDate(time).getTime();

  return new Date(time - 1000 * 60 * 60 * 24);
};

const getNextDate = (time) => {
  time = _getDate(time).getTime();
  return new Date(time + 1000 * 60 * 60 * 24);
};

const isFlashEnabled = () => {
  let hasFlash = false;
  try {
    // @ts-ignore
    const fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
    if (fo) hasFlash = true;
  } catch (e) {
    if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) hasFlash = true;
  }
  return hasFlash;
};

const insertSWF = (url, id, width, height, isReady, success, overTime, flashvars) => {
  const params = {
    quality: 'high',
    allowscriptaccess: 'always',
    allowfullscreen: 'false',
    wmode: 'transparent',
    flashvars: '',
  };
  const attr = {
    id,
    name: id,
    align: 'middle',
  };
  const version = '9';

  if (flashvars) {
    // @ts-ignore
    params.flashvars = $.param(flashvars);
  }

  // (swfUrlStr, replaceElemIdStr, widthStr, heightStr, swfVersionStr, xiSwfUrlStr, flashvarsObj, parObj, attObj, callbackFn)
  // @ts-ignore
  swfobject.embedSWF(
    url,
    id,
    width,
    height,
    version,
    'https://img.sumeme.com/swf/expressInstall.swf',
    {},
    params,
    attr,
    (e) => {
      if (!isFunction(isReady) || !isFunction(success)) {
        return;
      }

      let _loadCount = 0;
      const _loadIntervalId = setInterval(() => {
        _loadCount++;

        // @ts-ignore
        const tempSwf = swfobject.getObjectById(id);

        if (isReady(tempSwf)) {
          success(tempSwf);

          clearInterval(_loadIntervalId);
        }

        if (_loadCount > 20) {
          if (isFunction(overTime)) {
            overTime();
          }
          clearInterval(_loadIntervalId);
        }
      }, 300);
    },
  );
};

const toPercent = (num, count, total = false) => {
  if (total) {
    if (num === count) {
      return '50%';
    }

    count = num + count;
  }

  const result: any =
    // eslint-disable-next-line no-nested-ternary
    !num || num <= 0 || !count ? 0 : num >= count ? 1 : num / count;

  return `${result * 100}%`;
};

/**
 * 获取人民币格式
 * @param num，单位：分
 * @private
 */
function getCny(num) {
  return ((num || 0) / 100).toFixed(2);
}

/**
 * 过滤 object 中为null的节点
 * @param obj
 */
function filterObject(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === null) {
      delete obj[key];
    } else if (typeof obj[key] === 'object') {
      filterObject(obj[key]);
    }
  });
  return obj;
}

export {
  formatStr,
  formatNum,
  getLastTime,
  getRemainTime,
  formatTime,
  getRandomString,
  transformKeys,
  getConstellation,
  getRangeNum,
  getViewCount,
  formatImgUrl,
  formatImgSize,
  loadJs,
  loadModuleJs,
  scrollTop,
  scrollBottom,
  parseQueryString,
  getSaIndex,
  reload,
  cssPx2ViewportPx,
  navBack,
  clearBackTimer,
  getTimerText,
  getRAF,
  getCAF,
  redirectRoom,
  getMonthLastDate,
  getMonthFirstDate,
  getNextMonthFirstDate,
  getPrevDate,
  getNextDate,
  isFlashEnabled,
  insertSWF,
  getCny,
  toPercent,
  filterObject,
};
